import { useTranslate } from 'react-polyglot';

import type { QuestionAnalytics } from '../../../../utils/buildQuestionAnalytics';
import { getQuestionText } from '../../../../utils/getQuestionText';
import { SectionTitle } from '../common/SectionTitle.styled';
import { QuestionCards } from './components/QuestionCards/QuestionCards';
import { QuestionResultChart } from './components/QuestionResultChart/QuestionResultChart';
import { QuestionUserResults } from './components/QuestionUserResults/QuestionUserResults';
import { ScrollArea } from './QuestionAnalyticsView.styled';

interface QuestionAnalyticsViewProps {
  analytics: QuestionAnalytics;
}

/**
 * The analytics read of the question the host just resolved, stacked into the side panel.
 * An open answer question stops after the second section: its list of texts is already the
 * per-user reading, so a third section would be the same information twice in one scroll.
 */
export const QuestionAnalyticsView = ({ analytics }: QuestionAnalyticsViewProps) => {
  const t = useTranslate();

  const { question, kind, isRandom, cards, chart } = analytics;

  const hasUserSection = chart.kind !== 'openAnswers';

  const questionText = getQuestionText(question, isRandom, t);

  return (
    <ScrollArea>
      <SectionTitle>{t('__new.play.analyticsResults.question.summary')}</SectionTitle>
      <QuestionCards cards={cards} />

      <SectionTitle>
        {t('__new.play.analyticsResults.question.overallResult')}
      </SectionTitle>
      <QuestionResultChart
        chart={chart}
        questionText={questionText}
        isRating={kind === 'rating'}
      />

      {hasUserSection && <QuestionUserResults analytics={analytics} />}
    </ScrollArea>
  );
};
